import React from 'react';
import {
    DocumentTextIcon,
    CheckBadgeIcon,
    TableCellsIcon,
    CurrencyDollarIcon,
    PhoneIcon,
    UsersIcon,
    PlusIcon
} from '@heroicons/react/24/outline';
import simplia from '../../../../img/simplia.png';

export const TabNavigation = ({ activeTab, setActiveTab, setSelectedId, data }) => {
    const tabs = [
        { id: 'GESTION', name: 'Gestión', icon: DocumentTextIcon, color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-200', activeRing: 'ring-blue-400' },
        { id: 'VERIFICACION', name: 'Verificación', icon: CheckBadgeIcon, color: 'text-emerald-600', bg: 'bg-emerald-50', border: 'border-emerald-200', activeRing: 'ring-emerald-400' },
        { id: 'TABLA DE AMORTIZACION', name: 'Amortización', icon: TableCellsIcon, color: 'text-indigo-600', bg: 'bg-indigo-50', border: 'border-indigo-200', activeRing: 'ring-indigo-400' },
        { id: 'PAGOS', name: 'Pagos', icon: CurrencyDollarIcon, color: 'text-green-600', bg: 'bg-green-50', border: 'border-green-200', activeRing: 'ring-green-400' },
        { id: 'FACTURA', name: 'Factura', icon: DocumentTextIcon, color: 'text-indigo-600', bg: 'bg-indigo-50', border: 'border-indigo-200', activeRing: 'ring-indigo-400' },
        { id: 'TELEFONOS', name: 'Teléfonos', icon: PhoneIcon, color: 'text-rose-600', bg: 'bg-rose-50', border: 'border-rose-200', activeRing: 'ring-rose-400' },
        { id: 'REFERENCIAS', name: 'Referencias', icon: UsersIcon, color: 'text-orange-600', bg: 'bg-orange-50', border: 'border-orange-200', activeRing: 'ring-orange-400' },
        { id: 'SAVE_GESTION', name: 'Ingresar Gestión', icon: PlusIcon, color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-200', activeRing: 'ring-blue-400', action: () => setActiveTab('SAVE_GESTION') },
        { id: 'SIMPLIA', name: 'Simplia', image: simplia, color: 'text-cyan-700', bg: 'bg-cyan-50', border: 'border-cyan-200', activeRing: 'ring-cyan-400', action: () => { setSelectedId(data?.idCompra); setActiveTab('SIMPLIA'); } }
    ];

    return (
        <div className="px-6 py-3 flex flex-wrap items-center gap-2 border-b-2 border-slate-200 bg-white shrink-0 z-10 relative shadow-sm">
            {tabs.map(tool => {
                const isActive = activeTab === tool.id;
                return (
                    <button
                        key={tool.id}
                        onClick={tool.action ? tool.action : () => setActiveTab(tool.id)}
                        disabled={tool.disabled}
                        className={`flex items-center gap-2 px-3.5 py-2 rounded-xl font-bold text-[11px] transition-all duration-200 transform border ${tool.border} ${tool.bg} ${tool.color} ${isActive
                                ? `ring-2 ring-offset-2 ring-offset-white ${tool.activeRing} shadow-md scale-[1.02]`
                                : 'opacity-100 hover:scale-[1.02] shadow-sm hover:shadow-md'
                            } ${tool.disabled ? 'opacity-50 cursor-not-allowed scale-100 hover:scale-100' : ''}`}
                    >
                        {tool.image ? (
                            <img src={tool.image} alt={tool.name} className="h-4 object-contain" />
                        ) : (
                            <>
                                <tool.icon className="w-4 h-4" />
                                {tool.name}
                            </>
                        )}
                    </button>
                );
            })}
        </div>
    );
};
